import Vue from "vue";

const Refus = {
    namespaced: true,
    state: {
        refus: []
    },
    actions: {
        getRefus(context, params) {
            return new Promise((resolve, reject) => {
                Vue.axios.get(window.urlapi + "getDemande.php?mode=getRefus&dossier=" + params.dossier + "&platform=mobile&marker=" + params.layername + "&id_dossier=" + params.id).then(
                    response => {
                        context.commit("GETREFUS", response.data.data);
                        resolve();
                    }
                );
            });
        }
    },
    mutations: {
        GETREFUS: (state, refus) => {
            state.refus = refus;
        }
    },
    getters: {
        refus: state => {
            return state.refus;
        }
    }
}

export default Refus;